import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de4ef024"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "title"]

import { toRefs, inject, ref, watch } from 'vue';

import { SwiperSlide } from '@/support/interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoEmbedWrapper',
  props: {
    title: null,
    source: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string;
  source: string;
}

const aspectRatio: number = 9 / 16;



const { title, source } = toRefs(props);

const swiper = inject<SwiperSlide>('swiperSlide', {
  isActive: false,
});

const iframePlayer = ref<any>(null);

const isPlaying = ref(false);

const playOrPauseVideo = (shouldPlay: boolean) => {
  iframePlayer.value?.contentWindow.postMessage(
    JSON.stringify({
      event: 'command',
      func: shouldPlay ? 'playVideo' : 'pauseVideo',
    }),
    '*'
  );
};

watch(swiper, (newValue) => {
  playOrPauseVideo(newValue.isActive);
});

const togglePlayVideo = () => {
  isPlaying.value = !isPlaying.value;

  playOrPauseVideo(isPlaying.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "video-wrapper",
    style: _normalizeStyle({ '--aspect-ratio': aspectRatio })
  }, [
    _createElementVNode("iframe", {
      ref_key: "iframePlayer",
      ref: iframePlayer,
      src: `${_unref(source)}?enablejsapi=1&controls=0`,
      title: _unref(title),
      frameborder: "0",
      allow: "autoplay; clipboard-write; encrypted-media; gyroscope;",
      allowfullscreen: ""
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: "overlay",
      onClick: togglePlayVideo
    })
  ], 4))
}
}

})